import styled from 'styled-components'
import { Link } from 'gatsby'

export const OuterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;

  @media (max-width: 767px) {
    padding: 42px 0;
  }
`

export const InnerContainer = styled.div`
  max-width: 720px;

  @media (max-width: 767px) {
    max-width: 80%;
  }
`

export const PostDate = styled.p`
  font-size: 1rem;
  letter-spacing: 0.1rem;
  color: #666666;
  text-transform: uppercase;
`

export const PostDateLarge = styled.span`
  font-size: 1.3rem;
`

export const TitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
`

export const Title = styled.p`
  font-size: 3rem;
  list-style: 3.8rem;
  margin: 0 auto 0 0;
`

export const DesktopShareContainer = styled.div`
  display: contents;

  @media (max-width: 767px) {
    display: none;
    flex-direction: column;
  }
`

export const MobileShareContainer = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: flex;
    gap: 4px;
    margin: 16px 0;
  }
`

export const Subtitle = styled.div`
  font-family: FairplexBook;
  font-style: italic;
  font-size: 2rem;
  line-height: 2.6rem;
  margin-top: 12px;
  margin-bottom: 28px;

  @media (max-width: 767px) {
    margin-bottom: 0;
  }
`

export const Caption = styled.div`
  font-family: VerlagLight;
  font-size: 1.6rem;
  line-height: 2.2rem;
  color: #666666;
  width: 100%;
  margin-top: 6px;

  & p:first-child {
    margin-top: 0;
  }
`

export const BodyText = styled.div`
  font-family: FairplexBook;
  font-size: 1.6rem;
  line-height: 2.2rem;
  margin-top: 20px;

  & > p:first-child {
    margin-top: 0;
  }

  & > p:last-child {
    margin-bottom: 0;
  }

  & img {
    max-width: 100%;
    margin: 28px auto;
    display: block;
  }

  & ul {
    list-style-type: none;
    padding-inline-start: 20px;
    padding-inline-end: 20px;
  }

  & li {
    padding-left: 10px;
    text-indent: -10px;
  }
`

export const NextPreviousContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 72px;

  & a {
    display: flex;
    align-items: center;
    font-size: 1.6rem;
    letter-spacing: 0.1rem;
    color: #666666;
    text-decoration: none;
  }
`

export const PreviousArrow = styled.div`
  color: var(--orange);
  font-size: 2.8rem;
  margin-right: 34px;
  transform: translateY(-1px);

  @media (max-width: 767px) {
    margin-right: 16px;
  }
`

export const NextArrow = styled(PreviousArrow)`
  margin-left: 34px;
  margin-right: 0;

  @media (max-width: 767px) {
    margin-left: 16px;
  }
`

export const TagRow = styled.div`
  font-family: VerlagBlack;
  font-size: 1.2rem;
  letter-spacing: 0.1rem;
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 64px;
  flex-wrap: wrap;

  & a {
    text-decoration: none;
  }
`

export const Tag = styled.div`
  font-family: VerlagBold;
  font-size: 1.2rem;
  text-transform: uppercase;

  color: var(--orange);
  border: 1px solid var(--lightGrey);
  padding: 4px;
`

export const RelatedPostsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 64px;
  gap: 54px;
  max-width: 570px;

  @media (max-width: 767px) {
    gap: 32px;
    max-width: 100%;
  }
`

export const RelatedPost = styled(Link)`
  display: grid;
  grid-template-columns: 192px 1fr;
  column-gap: 48px;
  align-items: start;
  text-decoration: none;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`

export const RelatedPostTitle = styled.p`
  font-size: 2rem;
  list-style: 2.8rem;
  margin-top: 0;
  margin-bottom: 12px;

  @media (max-width: 767px) {
    margin-top: 20px;
  }
`

export const RelatedPostSubtitle = styled.div`
  font-family: FairplexBook;
  font-size: 1.6rem;
  line-height: 2.2rem;
  color: #666666;
`
